import moment from "moment";
import BiDirectionType from "../types/BiDirectionType";

export default class DateTime {
	public static DEFAULT_DATE_FORMAT: string = "YYYY-MM-DD";
	public static FULL_DATE_DISPLAY_FORMAT: string = "ddd Do MMM YYYY";
	public static DATE_DISPLAY_FORMAT: string = "Do MMM YYYY";
	public static TIME_DISPLAY_FORMAT: string = "h:mm A";
	public static FORTNIGHT: number = 14;

	public static generateYearsFrom(
		year: number,
		numberOfYears: number,
		direction: BiDirectionType
	): number[] {
		const years: number[] = [year];

		let currentYear: number = year;

		for (let i = 0; i < numberOfYears - 1; i++) {
			if (direction === "forward") {
				currentYear += 1;
			} else {
				currentYear -= 1;
			}
			years.push(currentYear);
		}

		return years;
	}

	public static generateMonths(): string[] {
		const months: string[] = [];

		for (let i = 0; i < 12; i++) {
			const currentMonth: string = moment().set("month", i).format("MM");

			months.push(currentMonth);
		}

		return months;
	}

	public static generateDatesFor(
		year: number | string,
		month: string
	): string[] {
		const dates: string[] = [];

		const currentDate: moment.Moment = moment(`${year}-${month}-01`);

		do {
			dates.push(currentDate.format("DD"));

			currentDate.add(1, "day");
		} while (currentDate.format("MM") === month);

		return dates;
	}
}
